import dayjs, { Dayjs } from "dayjs";

export default class EntitlementChangeViewModel {
    public changeAmount: number = 1;
    public goesIntoEffectOn: Dayjs = dayjs();
    public reason: string = '';
}